const initialState = {
    fieldPayload: [], 
  };
  
  const fieldReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_FIELD_PAYLOAD":
        return {
          ...state,
          fieldPayload: action.payload,
        };
        case "RESET_STATE":
      return initialState; 
      case 'UPDATE_FIELD_PAYLOAD':
        const updatedPayload = state.fieldPayload.map((field) =>
          field.dataName === action.payload.dataName
            ? { ...field, ...action.payload.updates } 
            : field
        );
          if (!updatedPayload.find(field => field.dataName === action.payload.dataName)) {
          updatedPayload.push(action.payload.updates);
        }
  
        return {
          ...state,
          fieldPayload: updatedPayload,
        };

        case 'REMOVE_FIELD_FROM_PAYLOAD':
      return {
        ...state,
        fieldPayload: state.fieldPayload.filter(
          (field) => field.dataName !== action.payload
        ),
      };
      default:
        return state;
    }
  };
  
  export default fieldReducer;
  

  